export default "__VITE_ASSET__uWsJaCgk__"